module.exports = __webpack_public_path__ + "img/implement-sections.e7e67c7e.png";